export const Icon = ({ title, iconUrl }) => {
	return <img title={title} src={iconUrl} style={{ height: "24px", width: "24px" }} alt={title}></img>;
};

const iconButtonStyle = () => {
	return {
		border: 0,
		padding: 0,
		height: "24px",
		width: "24px",
		cursor: "pointer",
		outline: "none",
		background: "transparent",
		margin: "2px",
	};
};

export const IconButton = ({ title, onClick, iconUrl, type = "button" }) => {
	return (
		<button type={type} style={iconButtonStyle()} onClick={onClick}>
			<Icon title={title} iconUrl={iconUrl} />
		</button>
	);
};
